export default "__VITE_ASSET__Csol9wJ$__"